import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Descriptions, message, Popconfirm, Space, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { formatDateTime } from 'utils/formatDate';

const permissionColors: Record<string, string> = {
  read: 'default',
  manage: 'blue',
  admin: 'red',
};

const ItemDetail = ({ item, apiCall }: { item: any; apiCall: any }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate: deleteItem, isPending: isDeleting } = useMutation({
    mutationFn: apiCall.delete.queryFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [apiCall.list.queryKey] });
      message.success('Assignment deleted successfully');
      navigate('/admin/wealth/user-assignments');
    },
  });

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Staff">
          {item.staff_email}
          {item.staff_name ? ` - ${item.staff_name}` : ''}
        </Descriptions.Item>
        <Descriptions.Item label="Staff Account ID">
          {item.staff_account_id}
        </Descriptions.Item>
        <Descriptions.Item label="User">
          {item.user_email || item.user_phone || item.user_id}
          {item.user_name ? ` - ${item.user_name}` : ''}
        </Descriptions.Item>
        <Descriptions.Item label="User ID">{item.user_id}</Descriptions.Item>
        <Descriptions.Item label="Permission">
          {item.permission ? (
            <Tag color={permissionColors[item.permission] || 'default'}>
              {item.permission}
            </Tag>
          ) : (
            '-'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Created">
          {formatDateTime(item.created_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated">
          {formatDateTime(item.updated_at)}
        </Descriptions.Item>
      </Descriptions>

      <Popconfirm
        title="Delete this assignment?"
        description="The staff member will no longer see this user in Wealth."
        okText="Delete"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
        onConfirm={() => deleteItem({ id: item.id })}
      >
        <Button danger loading={isDeleting}>
          Delete Assignment
        </Button>
      </Popconfirm>
    </Space>
  );
};

export default ItemDetail;
